
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import capability from '../../assets/capability-1.svg'
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";


export default function DigitalCapabilities() {
    const nav = useNavigate()

    const capabilities = [
        {
            icon: capability,
            topic: 'App Development',
            navigator: 'Engineering & Platforms',
            content: 'Mobile applications built for usability and seamless system integration.'
        },
        {
            icon: capability,
            topic: 'Web Development',
            navigator: 'Engineering & Platforms',
            content: 'Enterprise-grade web platforms built for performance, security, and scalability.'
        },
        {
            icon: capability,
            topic: 'AI & Machine Learning',
            navigator: 'Intelligence & Automation',
            content: 'Intelligent systems enabling automation, analysis, and smarter decisions.'
        },
        {
            icon: capability,
            topic: 'UI & UX Design',
            navigator: 'Design & Experience',
            content: 'Human-centered interfaces focused on clarity, adoption, and trust.'
        },
        {
            icon: capability,
            topic: 'Brand Systems',
            navigator: 'Design & Experience',
            content: 'Digital brand systems built for consistency, credibility, and value.'
        },
        {
            icon: capability,
            topic: 'Digital Marketing',
            navigator: 'Growth & Visibility',
            content: 'Data-driven digital strategies designed to improve visibility and measurable growth.'
        },
        {
            icon: capability,
            topic: 'IoT & Hardware Systems',
            navigator: 'Connected Systems',
            content: 'Connected devices, sensors, and monitoring systems integrated into digital platforms.'
        },
    ];

    // const [currentIndex, setCurrentIndex] = useState(0);
    // const [itemsPerView, setItemsPerView] = useState(3);
    // const [isPaused, setIsPaused] = useState(false);

    const swiperRef = useRef(null);

    // Responsive logic






    return (
        <section className="py-2 px-4 md:px-12 lg:px-24 my-6">
            <div className="mx-auto max-w-7xl px-4 md:px-6 flex justify-center items-center md:gap-10 relative">

                {/* LEFT ARROW – hidden on mobile */}
                <div
                    className="
        hidden md:flex
        bg-secondary-50 cursor-pointer absolute
        md:top-52
        lg:top-64
        md:-left-9
        lg:-left-12
        max-h-[75px] max-w-[41px]
        items-center justify-center
      "
                >
                    <IoIosArrowBack
                        onClick={() => swiperRef.current?.slidePrev()}
                        className="my-7 mx-3 text-secondary-500 text-2xl"
                    />
                </div>

                <div className="w-full">

                    {/* Title */}
                    <h2 className="font-bold text-2xl md:text-3xl lg:text-4xl mt-6">
                        Digital Capabilities We Build
                    </h2>

                    {/* Description */}
                    <p className="font-secondary text-black font-medium text-base md:text-lg lg:text-xl leading-relaxed py-4 max-w-5xl">
                        We specialize in building IT services, AI-driven platforms, IoT solutions,
                        and product-led digital systems engineered for scale and reliability.
                    </p>

                    {/* MOBILE ARROWS (bottom) – optional & neat */}
                    <div className="flex justify-end gap-6  md:hidden">
                        <button
                            onClick={() => swiperRef.current?.slidePrev()}
                            className="bg-secondary-50 p-3 rounded-full"
                        >
                            <IoIosArrowBack className="text-secondary-500 text-xl" />
                        </button>

                        <button
                            onClick={() => swiperRef.current?.slideNext()}
                            className="bg-secondary-50 p-3 rounded-full"
                        >
                            <IoIosArrowForward className="text-secondary-500 text-xl" />
                        </button>
                    </div>

                    {/* Carousel Wrapper */}
                    <div className="p-3 ">
                        <Swiper className="pb-3"
                            modules={[Navigation, Autoplay]}
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            loop={true}
                            speed={800}
                            spaceBetween={24}
                            autoplay={{
                                delay: 1000,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true,
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                },
                                640: {
                                    slidesPerView: 2,
                                },
                                1024: {
                                    slidesPerView: 3,
                                },
                            }}
                        >
                            {capabilities.map((capable, index) => (
                                <SwiperSlide key={index}>
                                    <div key={index}
                                                                        className="group bg-secondary-50 rounded-xl p-5 h-[286px] duration-700 flex-shrink-0
                                                    shadow-[0_0_0_1px_rgba(0,0,0,0.0),0_0_12px_rgba(0,0,0,0.08)] hover:shadow-[0_8px_0_-3px_#0da3ea] basis-[94%]
                                                    md:basis-1/2 lg:basis-[31.5%] "
                                                                    >
                                        <img
                                            src={capable.icon}
                                            alt={capable.topic}
                                        />

                                        <h5 className="text-black font-medium text-lg md:text-xl py-3">
                                            {capable.topic}
                                        </h5>

                                        <p className="font-secondary text-gray-500 text-sm md:text-base leading-relaxed">
                                            {capable.content}
                                        </p>

                                        <button
                                            onClick={() =>
                                                nav(`/services#${capable.navigator}`)
                                            }
                                            className="relative my-5 flex items-center justify-center
                        w-8 h-8 bg-white text-secondary-500 rounded-full
                        overflow-hidden shadow-md transition-all duration-700
                        group-hover:w-36 group-hover:rounded-full
                        active:translate-x-0.5 active:translate-y-0.5"
                                        >
                                            <span
                                                className="absolute right-4 flex items-center gap-2
                            text-sm font-semibold whitespace-nowrap
                            opacity-0 translate-x-2 transition-all duration-700
                            group-hover:opacity-100 group-hover:translate-x-0"
                                            >
                                                Learn More
                                                <FiArrowRight className="text-lg" />
                                            </span>

                                            <div
                                                className="flex items-center justify-center
                            transition-all duration-700
                            group-hover:opacity-0 group-hover:scale-75"
                                            >
                                                <FiArrowRight className="text-lg" />
                                            </div>
                                        </button>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>



                    {/* CTA */}
                    <div className="text-center my-5">
                        <button
                            onClick={() => nav('/capable')}
                            className="text-secondary-500 font-semibold text-base py-2.5 px-6 bg-white rounded-lg border border-secondary-500 hover:bg-secondary-500 hover:text-white transition duration-700">
                            Explore Our Capabilities
                        </button>
                    </div>

                </div>

                {/* RIGHT ARROW – hidden on mobile */}
                <div className="   hidden md:flex bg-secondary-50 cursor-pointer absolute md:top-52 lg:top-64 md:-right-7
        lg:-right-10 max-h-[75px] max-w-[41px] items-center justify-center">
                    <IoIosArrowForward
                        onClick={() => swiperRef.current?.slideNext()}
                        className="my-7 mx-3 text-secondary-500 text-2xl"
                    />
                </div>

            </div>
        </section>


    );
}



